import React from "react";
import { BsGear } from "react-icons/bs";
import { IoWarningOutline } from "react-icons/io5";

const SmallAlert = ({ type, message, status, functionToDo }) => {
    return (
        <>
            {status && (
                <div className="small_alert fade-in"><p><i><IoWarningOutline /></i> {message}</p> <button className="small_alert_btn" onClick={() => functionToDo(true)}>See settings <BsGear/></button></div>
            )}
        </>
    )
}

export default SmallAlert